export const pipesConfig = {
  pipes: [
    {
      id: 0,
      name: 'Pipe 1',
      segments: [
        { name: 'Pipe_Types_Standard_2302961' },
        { name: 'Pipe_Types_Standard_2302977' },
        { name: 'Pipe_Types_Standard_2302963' },
        { name: 'Pipe_Types_Standard_2302970' },
      ],
      animatedSegments: [
        {
          name: 'Pipe_Types_Standard_2302961',
          inputs: {
            textureRotation: -Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
        {
          name: 'Pipe_Types_Standard_2302977',
          inputs: {
            textureRotation: Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
      ],
    },
    {
      id: 1,
      name: 'Pipe 2',
      segments: [
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2177270' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2177299' },
        { name: 'Pipe_Types_Standard_2177264' },
        { name: 'Pipe_Types_Standard_2177268' },
        { name: 'Pipe_Types_Standard_2177297' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2177985' },
        { name: 'Pipe_Types_Standard_2177295' },
        { name: 'Pipe_Types_Standard_2177850' },
        { name: 'Pipe_Types_Standard_2202212' },
        { name: 'Pipe_Types_Standard_2177969' },
        { name: 'Pipe_Types_Standard_2178547' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2191430' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2191430' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2192067' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2191555' },
        { name: 'Pipe_Types_Standard_2178766' },
        { name: 'Pipe_Types_Standard_2178886' },
        { name: 'Pipe_Types_Standard_2191431' },
        { name: 'Pipe_Types_Standard_2191185' },
        { name: 'Pipe_Types_Standard_2191925' },
        { name: 'Pipe_Types_Standard_2192007' },
        { name: 'Pipe_Types_Standard_2192087' },
        { name: 'Flexible_Coupling_3_Type_3_2251381' },
        { name: 'Pipe_Types_Standard_2192068' },
        { name: 'Pipe_Types_Standard_2202024' },
        { name: 'Flexible_Coupling_3_Type_3_2228342' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2191260' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2191933' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2202032' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2192095' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2191573' },
        { name: 'M_Transition_-_Welded_-_Generic_Standard_2320962' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2191426' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2202211' },
        { name: 'Pipe_Types_Standard_2279517' },
        { name: 'Pipe_Types_Standard_2276814' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2280930' },
        { name: 'Pipe_Types_Standard_2280917' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2281031' },
        { name: 'Pipe_Types_Standard_2281021' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2282110' },
        { name: 'Pipe_Types_Standard_2281509' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2282112' },
        { name: 'Pipe_Types_Standard_2281677' },
        { name: 'Pipe_Types_Standard_2282113' },
      ],
      animatedSegments: [
        {
          name: 'Pipe_Types_Standard_2177850',
          inputs: {
            textureRotation: -Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
        {
          name: 'Pipe_Types_Standard_2177264',
          inputs: {
            textureRotation: -Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
        {
          name: 'Pipe_Types_Standard_2202212',
          inputs: {
            textureRotation: Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
      ],
    },
    {
      id: 2,
      name: 'Pipe 3',
      segments: [
        { name: 'Pipe_Types_Standard_2028391' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2028393' },
        { name: 'Pipe_Types_Standard_2028387' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2028389' },
        { name: 'Pipe_Types_Standard_2028382' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2028384' },
        { name: 'Pipe_Types_Standard_2024658' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2028402' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2028398' },
        { name: 'Pipe_Types_Standard_2024792' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2030301' },
        { name: 'Pipe_Types_Standard_2030293' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2030319' },
        { name: 'Pipe_Types_Standard_2030307' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2030475' },
        { name: 'Pipe_Types_Standard_2028396' },
        { name: 'Pipe_Types_Standard_2024670' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2024675' },
        { name: 'Pipe_Types_Standard_2031040' },
        { name: 'Fitting-Tee-Equal_Reducing-Flanged-Anvil-CI-811_812-Fla_11e55ff' },
        { name: 'Pipe_Types_Standard_2014678' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2024677' },
        { name: 'Pipe_Types_Standard_2021265' },
      ],
      animatedSegments: [
        {
          name: 'Pipe_Types_Standard_2024792',
          inputs: {
            textureRotation: -Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
        {
          name: 'Pipe_Types_Standard_2024670',
          inputs: {
            textureRotation: -Math.PI / 2,
            offsetSpeedX: 0.0003,
            offsetSpeedY: 0,
          },
        },
      ],
    },
    {
      id: 3,
      name: 'Pipe 4',
      segments: [
        { name: 'Pipe_Types_Standard_2335688' },
        { name: 'Pipe_Types_Standard_2335563' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2335567' },
        { name: 'Pipe_Types_Standard_2335565' },
        { name: 'M_Globe_Valve_-_50-450_mm_-_Flanged_100_mm_2335581' },
        { name: 'M_Globe_Valve_-_50-450_mm_-_Flanged_100_mm_2335581' },
        { name: 'Pipe_Types_Standard_2335571' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2335573' },
        { name: 'Pipe_Types_Standard_2335569' },
        { name: 'Pipe_Types_Standard_2335652' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2335737' },
        { name: 'Pipe_Types_Standard_2335725' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2337089' },
        { name: 'Pipe_Types_Standard_2335768' },
        { name: 'M_Transition_-_Welded_-_Generic_Standard_2337101' },
        { name: 'M_Tee_-_Welded_-_Generic_Standard_2337093' },
        { name: 'Pipe_Types_Standard_2337094' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2375125' },
        { name: 'Pipe_Types_Standard_2375123' },
        { name: 'Pipe_Types_Standard_2358236' },
        { name: 'Pipe_Types_Standard_2337079' },
        { name: 'M_Elbow_-_Welded_-_Generic_Standard_2337970' },
        { name: 'Pipe_Types_Standard_2337962' },
      ],
      animatedSegments: [],
    },
    // Add more pipes as needed
  ],
};

export const segmentToPipeMap = new Map();
pipesConfig.pipes.forEach((pipe) => {
  pipe.segments.forEach((segment) => {
    segmentToPipeMap.set(segment.name, pipe);
  });
  pipe.animatedSegments.forEach((segment) => {
    segmentToPipeMap.set(segment.name, pipe);
  });
});
